// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.config.productionTip = false

Vue.use(VueFire);
Vue.use(Vuetify);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBjZBtThl8wf9N9a2eQpxW1ePnrxt5tcCQ',
    libraries: ''
  },
})

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDWy2oukmVK5DuiZTdGpNZdBSYfVU9kwiQ",
  authDomain: "puertodefrutos-prod.firebaseapp.com",
  databaseURL: "https://puertodefrutos-prod.firebaseio.com",
  projectId: "puertodefrutos-prod",
  storageBucket: "puertodefrutos-prod.appspot.com",
  messagingSenderId: "961668268847"
};
firebase.initializeApp(config);

export const db = firebase.firestore();
export const storage = firebase.storage();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js